const AUTH_QUERY_PARAMS = ['cp-token', 'contactId'];
const RESET_QUERY_PARAMS = ['fToken'];

function removeQueryParamsFromCurrentUrl(params: string[]): void {
  const url = new URL(window.location.href);
  let changed = false;

  params.forEach((param) => {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      changed = true;
    }
  });

  if (changed) {
    window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  }
}

/** Removes one-time login credentials from the address bar and browser history. */
export function removeAuthParamsFromCurrentUrl(): void {
  removeQueryParamsFromCurrentUrl(AUTH_QUERY_PARAMS);
}

/** Removes a password-reset credential after the page has captured it. */
export function removeResetTokenFromCurrentUrl(): void {
  removeQueryParamsFromCurrentUrl(RESET_QUERY_PARAMS);
}
